import { ModalProps, useMediaQuery } from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/modal'
import { useTranslation } from 'react-i18next'
import { Card } from 'components/card/card'
import { boxShadow } from 'theme/common-style'
import { useState, useEffect } from 'react'
import { ESTIMATE } from './estimate.i18n'
import { EstimateForm } from './estimate-form'

type Props = Pick<ModalProps, 'isOpen' | 'onClose'> & {
  projectData: any
  currentWorkOrder?: any
  vendor: any
  property: any
  selectedEstimateId: number | null
  vendorTrades: any
}

const AddNewEstimateModal: React.FC<Props> = ({
  isOpen,
  onClose,
  projectData,
  currentWorkOrder,
  vendor,
  property,
  selectedEstimateId,
  vendorTrades
}) => {
  const { t } = useTranslation()
  const [isMobile] = useMediaQuery('(max-width: 480px)')

  const [modalSize, setModalSize] = useState<string>('4xl')

  useEffect(() => {
    if (isMobile) {
      setModalSize('sm')
    } else {
      setModalSize('4xl')
    }
  }, [isMobile])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={modalSize} variant="custom">
      <ModalOverlay />
      <ModalContent minH="700px">
        <ModalHeader data-testid="new_estimate">
          {selectedEstimateId ? `Edit Estimate: ${selectedEstimateId}` : t(`${ESTIMATE}.newEstimate`)}
        </ModalHeader>
        <ModalCloseButton _hover={{ bg: 'blue.50' }} _focus={{ outline: 'none' }} />

        <ModalBody bg="bgGlobal.50" p={2}>
          <Card style={boxShadow}>
            <EstimateForm
              currentWorkOrder={currentWorkOrder}
              onClose={onClose}
              projectData={projectData}
              property={property}
              vendor={vendor}
              selectedEstimateId={selectedEstimateId}
              vendorTrades={vendorTrades}
            />
          </Card>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default AddNewEstimateModal
